module.exports = __webpack_public_path__ + "img/118.9f72e5c6.png";